/***
 *
 *   ACCOUNT / SETTINGS NAV
 *   Phase 8 — reference SettingsNav as SubNav variant="rail".
 *   Sections: Profile, Password, Organization (owner), Projects (admin),
 *   Users (admin). No Notifications / Activity / Integrations nav items.
 *
 **********/

import { SubNav } from 'components/lib';
import { useTranslate } from 'app/translations.js';

export function AccountNav(props) {
    const { _t } = useTranslate();

    const items = [
        {
            link: '/app/settings/profile',
            label: _t('profile.label'),
            icon: 'user',
        },
        {
            link: '/app/settings/password',
            label: _t('password.label'),
            icon: 'lock',
        },
        {
            link: '/app/settings/organization',
            label: _t('organization.label'),
            permission: 'owner',
            icon: 'briefcase',
        },
        {
            link: '/app/settings/projects',
            label: _t('project.label.multiple'),
            permission: 'admin',
            icon: 'folder',
        },
        {
            link: '/app/settings/users',
            label: _t('user.label.multiple'),
            permission: 'admin',
            icon: 'users',
        },
    ];

    return <SubNav items={items} variant="rail" className={props.className} />;
}
